import axios from "axios";
import store from "redux/store";

// api
import api from "api/api";

class Statistics {
	static addPassengersTravelled(newPassengers) {
		const passengersTraveled = store.getState().airlineInfo.info.stats.passengersTraveled;
		const newPassengersTraveled = Object.entries(passengersTraveled).reduce((t, [key, value], i) => {
			if (key === "total") {
				t[key] = value + newPassengers.reduce((total, val) => total + val, 0);
				return t;
			}

			t[key] = value + newPassengers[i - 1];
			return t;
		}, {});

		store.dispatch({ type: "SET_PASSENGERS_TRAVELLED", payload: newPassengersTraveled });
		this.save();
	}

	static async save(statsToSave = store.getState().airlineInfo.info.stats) {
		try {
			await axios.put(`${api}/airline/statistics`, statsToSave);
			console.log("Statistics saved!", statsToSave);
			return true;
		} catch (e) {
			console.error(e);
			return false;
		}
	}
}

export default Statistics;
